import iconRect from './iconRect';

const wqColor = {
  salinity: [
    {
      label: 'ไม่มีข้อมูล',
      rangeTitle: 'ข้อมูลไม่เพียงพอ',
      statusColor: '#BDBDBD',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '> 2',
      rangeTitle: '> 2',
      statusColor: '#B02318',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '> 0.5',
      rangeTitle: '> 0.5',
      statusColor: '#EE141F',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '> 0.25',
      rangeTitle: '> 0.25',
      statusColor: '#FFD966',
      color: '#000000',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '< 0.25',
      rangeTitle: '< 0.25',
      statusColor: '#66C803',
      color: '#000000',
      constrastColor: '#000',
      fontSize: '12px',
    },
  ],
  do: [
    {
      label: '< 2',
      rangeTitle: '< 2',
      statusColor: '#EE141F',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '> = 2',
      rangeTitle: '> = 2',
      statusColor: '#66C803',
      color: '#000000',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: 'ข้อมูลไม่เพียงพอ',
      rangeTitle: 'ข้อมูลไม่เพียงพอ',
      statusColor: '#BDBDBD',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
  ],
  ph: [
    {
      label: '> 9',
      rangeTitle: '> 9',
      statusColor: '#EE141F',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '< 5',
      rangeTitle: '< 5',
      statusColor: '#EE141F',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '5 - 9',
      rangeTitle: '5 - 9',
      statusColor: '#66C803',
      color: '#000000',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: 'ข้อมูลไม่เพียงพอ',
      rangeTitle: 'ข้อมูลไม่เพียงพอ',
      statusColor: '#BDBDBD',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
  ],
  eq: [
    {
      label: '> 500',
      rangeTitle: '> 500',
      statusColor: '#EE141F',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '< 500',
      rangeTitle: '< 500',
      statusColor: '#66C803',
      constrastColor: '#000',
      fontSize: '12px',
    },
  ],
  turbid: [
    {
      label: '> 1,000',
      rangeTitle: '> 1,000',
      statusColor: '#EE141F',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '100 - 1,000',
      rangeTitle: '100 - 1,000',
      statusColor: '#FFD966',
      color: '#000000',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '<= 100',
      rangeTitle: '<= 100',
      statusColor: '#66C803',
      color: '#000000',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: 'ข้อมูลไม่เพียงพอ',
      rangeTitle: 'ข้อมูลไม่เพียงพอ',
      statusColor: '#BDBDBD',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
  ],
  tds: [
    {
      label: '> 2,001',
      rangeTitle: '> 2,001',
      statusColor: '#EE141F',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '1,001 - 2,000',
      rangeTitle: '1,001 - 2,000',
      statusColor: '#FFD966',
      color: '#000000',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: '< 1,000',
      rangeTitle: '< 1,000',
      statusColor: '#66C803',
      color: '#000000',
      constrastColor: '#000',
      fontSize: '12px',
    },
    {
      label: 'ข้อมูลไม่เพียงพอ',
      rangeTitle: 'ข้อมูลไม่เพียงพอ',
      statusColor: '#BDBDBD',
      color: '#FFFFFF',
      constrastColor: '#000',
      fontSize: '12px',
    },
  ],
};

const WaterQualityStatusColor = (wq, type) => {
  let status;
  let level = 0;

  function wqStatusColorSalinity(value) {
    const [salinity0, salinity1, salinity2, salinity3, salinity4] = wqColor.salinity;
    let color;
    let icon;
    if (value >= 2) {
      color = salinity1;
      icon = iconRect.crimson;
      level = 4;
    } else if (value >= 0.5 && value <= 1.9) {
      color = salinity2;
      icon = iconRect.red;
      level = 3;
    } else if (value >= 0.25) {
      color = salinity3;
      icon = iconRect.yellow;
      level = 2;
    } else if (value < 0.25) {
      color = salinity4;
      icon = iconRect.green;
      level = 1;
    } else {
      color = salinity0;
      icon = iconRect.grey;
      level = 0;
    }
    return { color, icon, level };
  }

  function wqStatusColorph(value) {
    const [ph0, ph1, ph2, ph3] = wqColor.ph;
    let color;
    let icon;
    if (value < 5) {
      color = ph1;
      icon = iconRect.red;
    } else if (value > 9) {
      color = ph0;
      icon = iconRect.red;
    } else if (value > 5 || value < 9) {
      color = ph2;
      icon = iconRect.green;
    } else {
      color = ph3;
      icon = iconRect.grey;
    }
    return { color, icon, level };
  }

  function wqStatusColordo(value) {
    const [do0, do1, do2] = wqColor.do;
    let color;
    let icon;
    if (value <= 2) {
      color = do0;
      icon = iconRect.red;
      level = 2;
    } else if (value > 2) {
      color = do1;
      icon = iconRect.green;
      level = 1;
    } else {
      color = do2;
      icon = iconRect.grey;
      level = 0;
    }
    return { color, icon, level };
  }

  function wqStatusColorTurbid(value) {
    const [tu0, tu1, tu2, tu3] = wqColor.turbid;
    let color;
    let icon;
    if (value > 1000) {
      color = tu0;
      icon = iconRect.red;
    } else if (value > 100 && value <= 1000) {
      color = tu1;
      icon = iconRect.yellow;
    } else if (value <= 100) {
      color = tu2;
      icon = iconRect.green;
    } else {
      color = tu3;
      icon = iconRect.grey;
    }
    return { color, icon, level };
  }

  function wqStatusColorEc(value) {
    const [eq0, eq1] = wqColor.eq;
    let color;
    let icon;
    if (value > 500) {
      color = eq0;
      icon = iconRect.red;
    } else {
      color = eq1;
      icon = iconRect.green;
    }
    return { color, icon, level };
  }

  function wqStatusColorTds(value) {
    const [tds0, tds1, tds2, tds3] = wqColor.tds;
    let color;
    let icon;
    if (value > 2001) {
      color = tds0;
      icon = iconRect.red;
    } else if (value >= 1001 && value <= 2000) {
      color = tds1;
      icon = iconRect.yellow;
    } else if (value < 1000) {
      color = tds2;
      icon = iconRect.green;
    } else {
      color = tds3;
      icon = iconRect.grey;
    }

    return { color, icon, level };
  }

  function NanData() {
    const [do2] = wqColor.do;
    const color = do2;
    const icon = iconRect.grey;
    return { color, icon, level };
  }

  if (type === 'salinity') {
    status = wqStatusColorSalinity(wq);
  } else if (type === 'ph') {
    status = wqStatusColorph(wq);
  } else if (type === 'do') {
    status = wqStatusColordo(wq);
  } else if (type === 'ec') {
    status = wqStatusColorEc(wq);
  } else if (type === 'turbid') {
    status = wqStatusColorTurbid(wq);
  } else if (type === 'tds') {
    status = wqStatusColorTds(wq);
  } else {
    status = NanData();
  }
  return status;
};

export default WaterQualityStatusColor;
